import * as React from 'react';
import {enhance} from './enhancer';
import {MailsForm} from '../../../components/Mails';
import {setState} from './state';
import {handler} from './handler';

function Create(props: any) {
  const state = setState();

  return (
    <div className="a__mails-create">
      <div className="b__title c__after-title">
        <h1>メールを作成する</h1>
      </div>
      <div className="b__form">
        <MailsForm create {...{...props, ...state, ...handler}} />
      </div>
    </div>
  );
}

export default enhance((props: any) => <Create {...props} />);
